import { Sounds } from '../../sounds';
import { TutorialSteps } from '../../prefabs/game/Tutorial';
import {Level, LevelMapName, LevelName} from './level';

export const Level15: Level = {
  id:LevelName.Level15,
  //smash levels are how many crates need to be smashed to reach X star goals
  smashLevels:{
    smashLevels: [50,75,100]
  },
  //target score is how many crates need to be smashed to unlock the next level
  targetScore:50,
  levelMap:LevelMapName.Level15,
  levelBackground:"bg-space.jpg",
  gameplayBackground:"gameplay-space.png",
  levelBackgroundAtlas:"game-space",
  friction:0.987,
  lives: 3,
  bumperDownKey:"bumper-down-space.png",
  tutorialStep:[TutorialSteps.None],
  arrowColor:0x182939,
  bgMusic:Sounds.Track.SpaceMusicLoop
}
